import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { PrimaryButton, SecondaryButton, TransparentButton, styleVariables } from '@lib/common';
import styled from '@xstyled/styled-components';
import { Button, Form, Input, Modal, Space, Tooltip } from 'antd';
import { useCallback, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var EXPLANATION = 'explanation';
var Layout = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: inherit;\n\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])));
var StyledWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var StyledLabel = styled.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  color: ", ";\n"])), styleVariables.colors.gray11);
var StyledUtilButton = styled(Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: none;\n\n  &:hover {\n    color: ", ";\n  }\n"])), styleVariables.colors.blue3);
var StyledInputContent = styled(Input)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  background: ", ";\n  color: ", " !important;\n"])), styleVariables.colors.gray3, styleVariables.colors.gray11);
var StyledQuestionContentTitle = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 16px;\n"])));
var StyledExplanationTextArea = styled(Input.TextArea)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: 16px;\n"])));
export var ExplanationComponent = function ExplanationComponent(_ref) {
  var question = _ref.question,
      form = _ref.form,
      onUpdateExplanation = _ref.onUpdateExplanation,
      explanationLabels = _ref.explanationLabels;

  var _useState = useState(false),
      isExplanationModalVisible = _useState[0],
      setExplanationModalVisibility = _useState[1];

  var _useState2 = useState(question.explanation && question.explanation.trim() !== '' && question.explanation.trim() !== '<p><br></p>'),
      isExplanationOptionVisible = _useState2[0],
      setExplanationOptionVisibility = _useState2[1];

  var handleOpenModal = useCallback(function () {
    form.setFieldValue(EXPLANATION, question.explanation);
    setExplanationModalVisibility(true);
  }, [form, question]);
  var handleCloseModal = useCallback(function () {
    setExplanationModalVisibility(false);
    form.resetFields();
  }, [form]);

  var handleUpdateExplanationConfirmation = function handleUpdateExplanationConfirmation() {
    onUpdateExplanation(EXPLANATION, form.getFieldValue(EXPLANATION));
    setExplanationOptionVisibility(form.getFieldValue(EXPLANATION) && form.getFieldValue(EXPLANATION) !== '' && form.getFieldValue(EXPLANATION) !== '<p><br></p>');
    setExplanationModalVisibility(false);
  };

  var renderExplainField = useCallback(function () {
    if (isExplanationOptionVisible) {
      return /*#__PURE__*/_jsxs(Layout, {
        children: [/*#__PURE__*/_jsxs(StyledWrapper, {
          children: [/*#__PURE__*/_jsx(StyledLabel, {
            children: explanationLabels.explanation
          }), /*#__PURE__*/_jsx(Tooltip, {
            title: explanationLabels.edit,
            placement: "top",
            children: /*#__PURE__*/_jsx(StyledUtilButton, {
              size: "small",
              icon: /*#__PURE__*/_jsx(EditOutlined, {}),
              onClick: handleOpenModal
            })
          })]
        }), /*#__PURE__*/_jsx(StyledInputContent, {
          disabled: true,
          value: question.explanation
        })]
      });
    }

    return /*#__PURE__*/_jsx(TransparentButton, {
      size: "middle",
      icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
      onClick: handleOpenModal,
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: explanationLabels.addExplanation
      })
    });
  }, [isExplanationOptionVisible, handleOpenModal, question.explanation, explanationLabels.explanation, explanationLabels.addExplanation, explanationLabels.edit]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderExplainField(), /*#__PURE__*/_jsxs(Modal, {
      open: isExplanationModalVisible,
      onCancel: handleCloseModal,
      centered: true,
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SecondaryButton, {
          onClick: handleCloseModal,
          size: "middle",
          children: explanationLabels.cancel
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          onClick: handleUpdateExplanationConfirmation,
          size: "middle",
          children: explanationLabels.confirm
        }), ","]
      }),
      children: [/*#__PURE__*/_jsx(StyledQuestionContentTitle, {
        children: explanationLabels.addExplanation
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: 'explanation',
        children: /*#__PURE__*/_jsx(StyledExplanationTextArea, {
          placeholder: explanationLabels.explanationPlaceholder,
          rows: 12
        })
      })]
    })]
  });
};